import { render } from "./OtherOptionTextForm.vue?vue&type=template&id=ae967a8c&scoped=true"
import script from "./OtherOptionTextForm.js?vue&type=script&lang=js&external"
export * from "./OtherOptionTextForm.js?vue&type=script&lang=js&external"

import "./OtherOptionTextForm.vue?vue&type=style&index=0&id=ae967a8c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ae967a8c"],['__file',"src/components/ChatWidget/OtherOptionTextForm/OtherOptionTextForm.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "ae967a8c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('ae967a8c', __exports__)) {
    api.reload('ae967a8c', __exports__)
  }
  
  module.hot.accept("./OtherOptionTextForm.vue?vue&type=template&id=ae967a8c&scoped=true", () => {
    api.rerender('ae967a8c', render)
  })

}


export default __exports__